import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ContactComponent } from './pages/contact/contact.component';
import { AboutComponent } from './pages/about/about.component';
import { CategoriesComponent } from './pages/categories/categories.component';
import { TermsConditionsComponent } from './pages/terms-conditions/terms-conditions.component';
import { HomeNewComponent } from './pages/home-new/home-new.component';
import { JobsComponent } from './pages/jobs/jobs.component';
import { CareersComponent } from './pages/careers/careers.component';
import { JobDetailsComponent } from './pages/careers/job-details/job-details.component';

const routes: Routes = [
  { path: '', component: HomeNewComponent, data: { title: 'Home' } },
  { path: 'contact', component: ContactComponent, data: { title: 'Contact Us' } },
  { path: 'about', component: AboutComponent, data: { title: 'Who we are' } },
  { path: 'categories', component: CategoriesComponent, data: { title: 'Categories' } },
  { path: 'jobs', component: JobsComponent, data: { title: 'Jobs' } },
  { path: 'terms-conditions', component: TermsConditionsComponent, data: { title: 'Terms and Conditions' } },
  { path: 'careers', component: CareersComponent, data: { hideLayout: true } },
  { path: 'careers/job-details/:company_id', component: JobDetailsComponent, data: { hideLayout: true } }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    scrollPositionRestoration: 'enabled'
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
